import React from 'react';
import { Container } from 'react-bootstrap';
import SectionHeader from '../SectionHeader/SectionHeader';
import Video from '../Video/Video';
import { headerWithDescType } from 'src/types';

function BlockWithVideo({ sectionHeader: { title, tagline, description }, youtubeVideoLink }) {
  return (
    <Container as="section" className="py-5">
      <SectionHeader title={title} tagline={tagline} description={description} />

      <div className="mt-3">
        <Video youtubeVideoLink={youtubeVideoLink} />
      </div>
    </Container>
  );
}

BlockWithVideo.propTypes = {
  sectionHeader: headerWithDescType.propTypes,
};

BlockWithVideo.defaultProps = {
  sectionHeader: headerWithDescType.defaultProps,
};

export default BlockWithVideo;
